import './App.css';
import Navbar from './component/Navbar';
import BannerSection from './component/BannerSection';
import About from './component/About';
import Experience from './component/Experience';
import Contact from './component/Contact';
import Footer from './component/Footer';
function App() {
  return (
    <div className="App">
      <Navbar />
      <BannerSection />
      <About />
      <Experience />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
